import React from 'react'
import Filters, { FilterGroup } from '../organisms/Filters'

export interface UnlockFiltersProps {
  search: string
  onSearchChange: (value: string) => void
  sortBy: 'VESTING_DATE_START' | 'VESTING_DATE_END' | 'AMOUNT' | 'PROJECT_NAME'
  onSortByChange: (value: 'VESTING_DATE_START' | 'VESTING_DATE_END' | 'AMOUNT' | 'PROJECT_NAME') => void
  sortDirection: 'ASC' | 'DESC'
  onSortDirectionChange: (value: 'ASC' | 'DESC') => void
  className?: string
}

const UnlockFilters: React.FC<UnlockFiltersProps> = ({
  search,
  onSearchChange,
  sortBy,
  onSortByChange,
  sortDirection,
  onSortDirectionChange,
  className
}) => {
  const filterGroups: FilterGroup[] = [
    {
      id: 'sortBy',
      label: 'Sort By',
      value: sortBy,
      onChange: (value: string) => onSortByChange(value as 'VESTING_DATE_START' | 'VESTING_DATE_END' | 'AMOUNT' | 'PROJECT_NAME'),
      options: [
        { value: 'VESTING_DATE_START', label: 'Vesting Start Date' },
        { value: 'VESTING_DATE_END', label: 'Vesting End Date' },
        { value: 'AMOUNT', label: 'Amount' },
        { value: 'PROJECT_NAME', label: 'Project Name' }
      ]
    },
    {
      id: 'sortDirection',
      label: 'Sort Direction',
      value: sortDirection,
      onChange: (value: string) => onSortDirectionChange(value as 'ASC' | 'DESC'),
      options: [
        { value: 'ASC', label: 'Ascending' },
        { value: 'DESC', label: 'Descending' }
      ]
    }
  ]

  return (
    <Filters
      searchPlaceholder="Search by project name..."
      searchValue={search}
      onSearchChange={onSearchChange}
      filterGroups={filterGroups}
      className={className}
      layout="horizontal"
    />
  )
}

export default UnlockFilters 